// Copyright ©️ 2026 eVolve MEP, LLC

import { Text } from '@mantine/core';

import { isNotNil } from 'helpers/isNotNil';

import type { CartBend } from '../Context/useBendCreatorCartContext';
import type { BendCreatorFormValues } from '../Context/useBendCreatorFormContext';
import classes from './BendDescription.module.css';
import { BendDimensions } from './BendDimensions';
import { BendMaterial } from './BendMaterial';

/** Returns a formatted description of the bend, or a loader if the required data is still loading */
export const BendDescription = ({ bend }: { bend: BendCreatorFormValues | CartBend }) => (
  <Text c="dimmed" fz="xs" span className={classes.bendDescription}>
    {isNotNil(bend.bendType) && <Text span>{bend.bendType}</Text>}
    <BendMaterial bend={bend} />
    <BendDimensions bend={bend} />
  </Text>
);
